module.exports = __webpack_public_path__ + "static/hero_background-b0daa2c378d1f863bec698d78ce49d4e.png";